// Enum values match backend `feature.key` slugs (see migration
// AddFeatureTableAndLastSeenFeature1777138423286). The frontend uses slugs as
// the source of truth for which AppTour steps reference a tracked feature; the
// numeric id ordering comes from the backend via /user-data/get-unseen-features.
export enum ApptourFeature {
  AUTO_TEMPO_ADJUSTMENT = 'auto_tempo_adjustment',
  REPERTOIRE_LOOPING = 'repertoire_looping',
  // Tips only the tour for players the app cannot hear shows (no MIDI
  // keyboard). Each needs its row in the backend `feature` table; until it
  // has one the server never lists it as unseen, so the tip stays hidden.
  UNGRADED_ACCURACY = 'ungraded_accuracy',
  UNGRADED_TEMPO = 'ungraded_tempo',
  UNGRADED_TIERS = 'ungraded_tiers',
  UNGRADED_REPERTOIRE_ACCURACY = 'ungraded_repertoire_accuracy',
}

// Mirrors the backend `Feature` entity row (id + key) — the only fields the
// frontend cares about for selecting and ordering walkthrough steps.
export interface ApptourFeatureItem {
  id: number;
  key: string;
}
